import { IGameProfile } from '@libs/shared/src/common/domains/game/game-profile';
import { gameProfileApi } from '@libs/shared/src/common/domains/game/GameProfileApi/GameProfileApi';

import { TopPlayersUi } from '../ui/components';
import { UI } from '../ui/ui';

import { GameScene } from './GameScene';

export class WithScoreScene extends GameScene {
  topPlayers: IGameProfile[];
  topPlayersUi: TopPlayersUi;
  uiUpdatedFromApi: boolean;

  constructor(sceneName: string) {
    super(sceneName);

    this.topPlayers = [];
  }

  async getTopPlayers() {
    this.topPlayers = [];
    const topPlayers = await gameProfileApi.getTopPlayers();
    this.topPlayers = [...topPlayers].sort((a, b) => (b.highScore > a.highScore ? 1 : -1)) || [];
  }

  updateTopPlayersUi() {
    if (!this.apiIsCalled) {
      this.apiIsCalled = true;
      this.getTopPlayers();
    }

    if (this.topPlayers.length && !this.uiUpdatedFromApi && this.apiIsCalled) {
      this.uiUpdatedFromApi = true;
      UI.components.UpdateTopPlayers(this.topPlayersUi, this.topPlayers, this);
    }
  }

  resetApiFlags() {
    this.apiIsCalled = false;
    this.uiUpdatedFromApi = false;
  }
}
